import * as r from 'ramda';
import { withProps } from '@team-griffin/rehook';
import { isInternalUrl, isHashUrl } from 'domain/url';
import { NavLink } from 'react-router-dom';

interface AnyProps {
  url?: string;
  action?: {
    url?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

export type UrlComponentType = typeof NavLink | 'a' | 'div';
const withUrlComponent = withProps((props: AnyProps) =>
  r.pipe(
    r.either(
      r.prop('url'),
      // @ts-ignore: error when upgrading to @ux/config
      r.path(['action', 'url']),
    ),
    r.cond([
      [
        r.isNil,
        () => ({
          Component: 'div',
        }),
      ],
      [
        isInternalUrl,
        (url) => ({
          Component: NavLink,
          to: url,
        }),
      ],
      [
        isHashUrl,
        (url) => ({
          Component: NavLink,
          to: url,
        }),
      ],
      [
        r.T,
        (url) => ({
          Component: 'a',
          href: url,
        }),
      ],
    ]),
    // @ts-ignore: error after upgrading eslint config. Please replace with relevant comment
  )(props),
);

export default withUrlComponent;
